exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul{list-style:inside}ol,ul{margin:0;padding:0}ol{list-style:decimal inside}", ""]);

// exports
